import { useState, useEffect } from "react";
import api from "../../services/api";

export default function Locales() {
  const [locales, setLocales] = useState([]);
  const [loading, setLoading] = useState(true);
  const [modalNuevo, setModalNuevo] = useState(false);
  const [nombreNuevo, setNombreNuevo] = useState("");

  useEffect(() => {
    cargar();
  }, []);

  const cargar = async () => {
    setLoading(true);
    try {
      const res = await api.get("/locales/todos");
      setLocales(res.data);
    } catch (err) {
      console.error(err);
    }
    setLoading(false);
  };

  const crearLocal = async () => {
    if (!nombreNuevo.trim()) {
      alert("Ponle un nombre al local");
      return;
    }
    try {
      await api.post("/locales", { nombre: nombreNuevo });
      setModalNuevo(false);
      setNombreNuevo("");
      cargar();
    } catch (err) {
      console.error(err);
      alert("Error al crear el local");
    }
  };

  const toggleLocal = async (id) => {
    try {
      await api.patch(`/locales/${id}/toggle`);
      cargar();
    } catch (err) {
      console.error(err);
      alert("Error al cambiar estado");
    }
  };

  const eliminarLocal = async (id) => {
    if (!window.confirm("¿Eliminar este local? Esta acción no se puede deshacer.")) return;
    try {
      await api.delete(`/locales/${id}`);
      cargar();
    } catch (err) {
      console.error(err);
      alert("Error al eliminar el local");
    }
  };

  const inputClass = "w-full mt-1 bg-[#E4E9F2] border border-[#E5E9F0] rounded-lg px-3 py-2.5 text-sm focus:outline-none focus:border-[#1A56DB] focus:ring-1 focus:ring-[#1A56DB]";
  const labelClass = "text-xs text-gray-500 uppercase tracking-wider font-medium";

  if (loading) {
    return <div className="text-center text-gray-400 py-12 text-sm">Cargando locales...</div>;
  }

  return (
    <div>
      <div className="flex items-center justify-between mb-4">
        <p className="text-sm text-gray-500">Gestiona los locales o sucursales de tu negocio</p>
        <button
          onClick={() => setModalNuevo(true)}
          className="bg-gradient-to-r from-[#0F1F4D] to-[#1A56DB] text-white text-sm font-medium px-4 py-2 rounded-lg shadow-sm"
        >
          + Agregar local
        </button>
      </div>

      <div className="bg-white border border-[#E5E9F0] rounded-xl overflow-x-auto shadow-sm">
        <table className="w-full text-sm">
          <thead>
            <tr className="text-xs text-gray-400 uppercase border-b border-[#E5E9F0]">
              <th className="text-left px-4 py-2">Nombre</th>
              <th className="text-left px-4 py-2">Estado</th>
              <th className="text-right px-4 py-2">Acciones</th>
            </tr>
          </thead>
          <tbody>
            {locales.map((l) => (
              <tr key={l.id} className="border-b border-[#E5E9F0]">
                <td className="px-4 py-3 font-medium text-gray-900">{l.nombre}</td>
                <td className="px-4 py-3">
                  <span className={`text-xs px-2 py-0.5 rounded-full font-medium border ${
                    l.activo ? "bg-green-50 text-green-700 border-green-200" : "bg-red-50 text-red-600 border-red-200"
                  }`}>
                    {l.activo ? "Activo" : "Inactivo"}
                  </span>
                </td>
                <td className="px-4 py-3 text-right space-x-2">
                  <button
                    onClick={() => toggleLocal(l.id)}
                    className={`text-xs font-medium px-3 py-1.5 rounded-lg ${
                      l.activo ? "bg-red-50 text-red-600 hover:bg-red-100" : "bg-green-50 text-green-700 hover:bg-green-100"
                    }`}
                  >
                    {l.activo ? "Desactivar" : "Activar"}
                  </button>
                  <button onClick={() => eliminarLocal(l.id)} className="text-red-600 text-xs font-medium hover:underline">
                    Eliminar
                  </button>
                </td>
              </tr>
            ))}
            {locales.length === 0 && (
              <tr>
                <td colSpan="3" className="text-center text-gray-400 py-8">No hay locales cargados todavía</td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      {modalNuevo && (
        <div className="fixed inset-0 bg-black/40 z-50 flex items-center justify-center backdrop-blur-sm p-4">
          <div className="bg-white border border-[#E5E9F0] rounded-2xl p-6 w-full max-w-sm shadow-xl">
            <h3 className="text-gray-900 font-semibold text-lg mb-4">Nuevo local</h3>
            <div className="mb-4">
              <label className={labelClass}>Nombre del local</label>
              <input
                type="text"
                value={nombreNuevo}
                onChange={(e) => setNombreNuevo(e.target.value)}
                className={inputClass}
                placeholder="Ej: Oeste, Centro, Sucursal 2"
              />
            </div>
            <div className="flex gap-2">
              <button onClick={crearLocal} className="flex-1 bg-gradient-to-r from-[#0F1F4D] to-[#1A56DB] text-white font-semibold py-2.5 rounded-lg">
                Crear
              </button>
              <button onClick={() => setModalNuevo(false)} className="bg-gray-100 text-gray-600 px-4 rounded-lg">
                Cancelar
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
